
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit2, Trash2 } from "lucide-react";
import { SubCategory } from "../../types/budget.types";

interface SubcategoryTableProps {
  subcategories: SubCategory[];
  openDetailsDialog: (bucketId: string, subcategory: SubCategory) => void;
  openEditDialog: (bucketId: string, subcategory: SubCategory) => void;
  openDeleteDialog: (bucketId: string, subcategory: SubCategory) => void;
  bucketId: string;
}

export const SubcategoryTable: React.FC<SubcategoryTableProps> = ({
  subcategories,
  openDetailsDialog,
  openEditDialog,
  openDeleteDialog,
  bucketId
}) => {
  // Sort subcategories alphabetically
  const sortedSubcategories = [...subcategories].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Table>
      <TableHeader>
        <TableRow className="hover:bg-secondary/5 text-[11px] text-left">
          <TableHead>Subcategory</TableHead>
          <TableHead>Budget</TableHead>
          <TableHead>Expected ROMI</TableHead>
          <TableHead>KPI</TableHead>
          <TableHead>Expected Completion</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedSubcategories.map(subcategory => (
          <TableRow key={subcategory.id} className="hover:bg-secondary/5 text-white text-[11px] text-left">
            <TableCell className="font-medium">{subcategory.name}</TableCell>
            <TableCell>${subcategory.budget.toLocaleString()}</TableCell>
            <TableCell>{subcategory.expRomi || "-"}</TableCell>
            <TableCell>{subcategory.kpi || "-"}</TableCell>
            <TableCell>
              {subcategory.expCompletion ? new Date(subcategory.expCompletion).toLocaleDateString() : "-"}
            </TableCell>
            <TableCell className="text-right">
              <div className="flex items-center justify-end gap-1">
                <Button 
                  size="sm" 
                  variant="ghost" 
                  className="h-8 w-8 p-0" 
                  onClick={() => openEditDialog(bucketId, subcategory)}
                >
                  <Edit2 className="h-3 w-3 text-primary-light" />
                </Button>
                <Button 
                  size="sm" 
                  variant="ghost" 
                  className="h-8 w-8 p-0 text-destructive hover:text-destructive" 
                  onClick={() => openDeleteDialog(bucketId, subcategory)}
                >
                  <Trash2 className="h-3 w-3" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
